__turbopack_context__.v({
  "raised": "comboBracket-module-scss-module__D4Ahpa__raised",
  "raisedIcon": "comboBracket-module-scss-module__D4Ahpa__raisedIcon",
});
